import { AlertTriangle, Building2, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { useTenant } from "@/hooks/useTenant";

export const SuspendedOverlay = () => {
    const { t } = useTranslation();
    const { data: tenant } = useTenant();

    return (
        <div className="fixed inset-0 z-[100] bg-background/95 backdrop-blur-sm">
            <div className="flex min-h-screen items-center justify-center px-4">
                <div className="w-full max-w-xl rounded-lg border bg-card p-8 shadow-xl">
                    <div className="mb-5 flex items-center gap-3 text-destructive">
                        <div className="flex h-11 w-11 items-center justify-center rounded-md bg-destructive/10">
                            <AlertTriangle className="h-5 w-5" />
                        </div>
                        <div>
                            <h2 className="text-xl font-semibold">{t("suspended.title")}</h2>
                            <p className="text-sm text-muted-foreground">
                                {tenant?.company_name || t("suspended.thisWorkspace")}
                            </p>
                        </div>
                    </div>

                    <div className="space-y-4 text-sm text-muted-foreground">
                        <p className="leading-6">
                            {t("suspended.description")}
                        </p>
                        <div className="grid gap-3 rounded-md border bg-muted/30 p-4">
                            <div className="flex items-center gap-2 text-foreground">
                                <Building2 className="h-4 w-4 text-primary" />
                                {t("suspended.lockActive")}
                            </div>
                            <div className="flex items-center gap-2 text-foreground">
                                <Mail className="h-4 w-4 text-primary" />
                                {t("suspended.contactAdmin")}
                            </div>
                        </div>
                    </div>

                    <div className="mt-6 flex flex-wrap gap-3">
                        <Button asChild>
                            <Link to="/company/billing">{t("suspended.openBilling")}</Link>
                        </Button>
                        <Button variant="outline" asChild>
                            <Link to="/company/billing">{t("suspended.billingRecovery")}</Link>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
